import { RefObject, useLayoutEffect, useState } from 'react';

/**
 * Tracks an element's content-box size via a ResizeObserver.
 * Returns `{ width, height }`, updating whenever the element resizes.
 */
export function useElementSize<T extends Element>(ref: RefObject<T | null>) {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new ResizeObserver((entries) => {
      const { width, height } = entries[0].contentRect;
      setSize({ width, height });
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);

  return size;
}
